module.exports = __webpack_public_path__ + "img/02.0baa659e.png";